import React from "react"
import styled from "styled-components"
import { Container } from "reactstrap"
import ReactPlayer from "react-player"
import scrollToElement from "scroll-to-element"
import { media } from "utils/Media"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons"
import classNames from "classnames"
import { GatsbyImage } from "gatsby-plugin-image"
import { LinkSearchReplace } from "utils/LinkSearchReplace"
import { useState } from "react"

const FaqBlockStyled = styled(Container)`
	margin-bottom: 1rem;
	width: 100%;

	.question {
		padding: 1rem 0;
		border: 0;
		border-top: 1px solid ${props => props.theme.colors.primary};
		position: relative;
		cursor: pointer;
		background: transparent;
		width: 100%;
		text-align: left;
		
		&.paddingLeft {
			padding-left: 47px;
		}
		
		&.active {
			color: ${props => props.theme.colors.black};
			
			p {
				color: ${props => props.theme.colors.black};
			}
		}
		
		svg.icon {
			font-size: 25px;
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			left: 5px;
		}
		
		svg.faq-arrow {
			font-size: 25px;
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			right: 0;
			max-height: 25px; 
			max-width: 25px; 
		}
	}

	.answer {
		padding-bottom: 1rem;
		
		p:last-child {
			margin: 0;
		}
		
		iframe {
			height: 288px;
			width: 100%;
			
			@media ${media.md} {
				height: 300px;
			}
			
			@media ${media.lg} {
				height: 330px;
			}
		}
		
		&.ratio-16x9 {
			height: auto !important;
			width: auto !important;
			iframe {
				height: 100%;
			}
		}
	}
`

const Question = styled.span`
	display: block;
	/* padding: .5rem 0; */
	margin: .5rem 0;
	p {
		margin: 0 !important;
	}
`

const FaqBlock = (props) => {
	const [openIndex, setOpenIndex] = useState(null)

  const changeOpenIndex = (e, index) => {
		e.preventDefault()
		if (openIndex === index) {
			index = null;
		}

		setOpenIndex(index)

		if (index !== null) {
			const el = e.target

			setTimeout(() => {
				scrollToElement(el, {
					offset: -120,
					duration: 500
				})
			}, 500)
		}
	}
    
	return (
		<FaqBlockStyled fluid>
			{props.data.faq && props.data.faq.map((faq, i) => {
				return (
					<div className="faq-row" key={i}>
						<button 
							className={classNames({
								question: true,
								active: i === openIndex
							})} 
							onClick={(e) => changeOpenIndex(e, i)}
						>
							<Question dangerouslySetInnerHTML={{ __html: faq.question }} />
							{openIndex === i ? (
								<FontAwesomeIcon className="faq-arrow" icon={faAngleUp} />
							) : (
								<FontAwesomeIcon className="faq-arrow" icon={faAngleDown} />
							)}
						</button>
							{openIndex === i &&
								faq.answerContent && faq.answerContent.map((block, i) => {
									switch (block.__typename) {
										case "WpPage_Acftwocolumnflexiblecontent_TwoColumnBlocks_FaqBlock_faq_AnswerContent_TextAnswer":
										case "WpNewsArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_FaqBlock_faq_AnswerContent_TextAnswer":
										case "WpPlayer_Acftwocolumnflexiblecontent_TwoColumnBlocks_FaqBlock_faq_AnswerContent_TextAnswer":
											return(
												<div 
													className="answer mb-4" 
													key={i} 
													dangerouslySetInnerHTML={{ __html: LinkSearchReplace(block.text) }} 
												/>
											)

										case "WpPage_Acftwocolumnflexiblecontent_TwoColumnBlocks_FaqBlock_faq_AnswerContent_ImageAnswer":
										case "WpNewsArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_FaqBlock_faq_AnswerContent_ImageAnswer":
										case "WpPlayer_Acftwocolumnflexiblecontent_TwoColumnBlocks_FaqBlock_faq_AnswerContent_ImageAnswer":
											return(
												<GatsbyImage 
													className="answer mb-4" 
													image={block.image.localFile.childImageSharp.gatsbyImageData} 
													alt={block.image.altText} key={i} 
												/>
											)

										case "WpPage_Acftwocolumnflexiblecontent_TwoColumnBlocks_FaqBlock_faq_AnswerContent_VideoAnswer":
										case "WpNewsArticle_Acftwocolumnflexiblecontent_TwoColumnBlocks_FaqBlock_faq_AnswerContent_VideoAnswer":
										case "WpPlayer_Acftwocolumnflexiblecontent_TwoColumnBlocks_FaqBlock_faq_AnswerContent_VideoAnswer":
											return(
												<ReactPlayer 
													url={block.video} 
													className="answer ratio ratio-16x9 mb-4" 
													key={i}  
												/>
											)

										default:
												return ""
									}
								})
							}
					</div>
				)
			})}
		</FaqBlockStyled>
	)
}

export default FaqBlock